export default __webpack_public_path__ + "static/media/ecom.c75178ee.png";